export default __webpack_public_path__ + "static/media/eg.e2f38452.svg";